<template>
  <div class="--drop">
    <template v-if="!sample || info">
      <v-file-input
        class="--file-input"
        :id="id"
        :multiple="!sample"
        v-model="files"
        @change="load"
      ></v-file-input>

      <v-card
        v-if="!sample || !info.length"
        :color="error ? `red lighten-4` : (dragover ? `blue lighten-3` : `grey lighten-3`)"
        @click="clickedCard()"
        class="text-center pa-3"
        outlined
        :style="error
          ? `border-color: red !important; border-style: dashed`
          : (dragover
            ? `border-color: #bce1ff !important; border-style:dashed lighten-3`
            : `border-color: #949494 !important; border-style: dashed`)"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
      >
        <div class="d-flex align-center justify-center" :class="error ? 'red--text text--darken-4' : 'grey--text text--darken-1'" style="gap: 10px; padding: 6px 0;">
          <v-icon
            :color="error ? 'red darken-2' : (dragover ? 'blue darken-1' : 'grey darken-1')"
            size="24"
          >
            mdi-cloud-upload-outline
          </v-icon>
          <span class="text-body-2">
            {{ $t('common.drop_to_upload') }}
          </span>
        </div>
      </v-card>

      <template v-else>
        <v-card v-if="!loadingProcessing">
          <div style="position: relative;">
            <v-img :src="(info[0] && info[0].data) || (snap && snap[0])" width="100%" height="200"></v-img>
            <v-btn
              icon
              style="position: absolute; top: 10px; right: 10px;"
              @click="remove(0)"
            >
              <v-icon color="red">mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
          <div v-if="sampleFile" class="px-4 py-3">
            <div class="d-flex align-center mb-2">
              <v-icon small color="green darken-1" class="mr-2">mdi-check-circle</v-icon>
              <span class="caption green--text text--darken-2 font-weight-bold">Arquivo enviado com sucesso</span>
            </div>

            <div class="caption grey--text text--darken-2 mb-1">
              <strong>Nome:</strong> {{ sampleFile.name || 'Nao informado' }}
            </div>
            <div class="caption grey--text text--darken-2 mb-1">
              <strong>Tamanho:</strong> {{ formatFileSize(sampleFile.size) }}
            </div>
          </div>
        </v-card>


        <v-skeleton-loader
          v-if="loadingProcessing"
          type="image"
          height="200"
        ></v-skeleton-loader>
      </template>

      <div class="pt-3"></div>
    </template>

    <div class="d-flex flex-wrap" :class="view === 'image' ? 'flex-row' : 'flex-column'">
      <div
        v-for="(item, index) in info"
        :key="index"
        :index="index"
        :item="item"
        :target="target"
        draggable="true"
        @dragstart="startDrag(item, index, $event)"
        @dragend="finishDrag(item, index, $event)"
        @dragover="(e) => onDragOver(item, index, e)"
      >
        <FileUploadItem
          :type="type"
          v-if="item"
          :view="view"
          :index="index"
          :item="item"
          :target="target"
          :sample="sample"
          @remove-item="remove($event)"
          @set-upload="upload($event, index)"
          @loading-processing="onLoadingProcessing"
        ></FileUploadItem>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploadItem from './FileUploadItem.vue'

export default {
  name: 'FileUpload',
  components: { FileUploadItem },
  props: {
    view: {
      required: false,
      type: String
    },
    unique: {
      required: false,
      type: Boolean
    },
    sample: {
      required: false,
      type: Boolean
    },
    label: {
      type: String
    },
    target: {
      type: String
    },
    error: {
      type: Boolean,
      required: false
    },
    snap: {
      type: [Array, Object, String],
      required: false
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      dragover: false,
      id: `id-${Math.floor(Math.random() * 999)}`,
      files: [],
      info: [],
      over: {},
      dragging: false,
      loadingProcessing: false,
      uploadingCount: 0
    }
  },
  mounted () {
    if (this.snap && this.snap.length) {
      // Clona os arquivos já existentes (ex: invoices já salvas)
      this.info = JSON.parse(JSON.stringify(this.snap))
    }
  },
  computed: {
    sampleFile () {
      if (!this.info || !this.info.length) return null
      return this.info[0]
    },
    sampleUploadedAt () {
      if (!this.sampleFile) return null
      const rawDate = this.sampleFile.created_at || this.sampleFile.createdAt || this.sampleFile.uploadedAt || this.sampleFile.updated_at
      if (!rawDate) return null

      const parsed = new Date(rawDate)
      if (Number.isNaN(parsed.getTime())) return null

      return parsed.toLocaleString('pt-BR')
    }
  },
  methods: {
    clickedCard () {
      document.getElementById(this.id).click()
    },

    remove (index) {
      this.info.splice(index, 1)
      this.$emit('set-upload', this.info)
    },

    onDrop (e) {
      e.preventDefault()
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        this.files.push(e.dataTransfer.files[i])
      }
      this.load()
    },

    load () {
      if (!this.files) return

      let selectedFiles = this.files
      if (!Array.isArray(selectedFiles)) {
        selectedFiles = [selectedFiles]
      }

      if (this.sample) {
        // Se for sample, apenas 1 arquivo
        selectedFiles = selectedFiles.slice(0, 1)
      }

      if (!selectedFiles.length) return

      selectedFiles.forEach(file => {
        if (!file || file.url) return
        this.getBase64(file).then(res => {
          const item = {
            data: res.currentTarget.result,
            name: file.name,
            size: file.size,
            type: file.type,
            File: file,
            customerInvoice: false // default para NF
          }
          this.info.push(item)
        })
      })

      // Limpa o input para permitir nova seleção
      this.files = this.sample ? null : []
    },

    upload (uploadedItem, index) {
      // Substitui o item da posição pelo retorno do servidor (com url, etc)
      if (typeof index === 'number') {
        const currentItem = this.info[index] || {}
        const mergedItem = {
          ...currentItem,
          ...uploadedItem,
          name: uploadedItem.name || currentItem.name,
          size: uploadedItem.size || currentItem.size,
          type: uploadedItem.type || currentItem.type
        }
        this.$set(this.info, index, mergedItem)
      } else {
        // fallback (não deve acontecer, mas por garantia)
        this.info.push(uploadedItem)
      }

      // Emite o array completo para o componente pai (BillingTable)
      this.$emit('set-upload', this.info)
      this.dragover = false
    },

    formatFileSize (size) {
      if (!size && size !== 0) return 'Nao informado'

      const num = Number(size)
      if (Number.isNaN(num) || num < 0) return 'Nao informado'
      if (num === 0) return '0 B'

      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      const i = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1)
      const value = num / Math.pow(1024, i)

      return `${value >= 10 || i === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[i]}`
    },

    getBase64 (file) {
      return new Promise((resolve, reject) => {
        if (file && !file.url) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = item => resolve(item)
          reader.onerror = error => reject(error)
        } else {
          reject(null)
        }
      })
    },

    startDrag (item, index, e) {
      this.dragging = true
      this.over = { pos: index }
    },

    finishDrag (item, fromIndex, e) {
      this.dragging = false
      if (this.over.pos === undefined || this.over.pos === fromIndex) {
        this.over = {}
        return
      }

      const toIndex = this.over.pos
      const moved = this.info.splice(fromIndex, 1)[0]
      this.info.splice(toIndex, 0, moved)

      this.over = {}
      this.$emit('set-upload', this.info)
    },

    onDragOver (item, index, e) {
      e.preventDefault()
      if (!this.dragging) return
      if (this.over.pos !== index) {
        this.over = { pos: index }
      }
    },

    onLoadingProcessing (isLoading) {
      if (isLoading) {
        this.uploadingCount++
      } else {
        this.uploadingCount = Math.max(0, this.uploadingCount - 1)
      }
      this.loadingProcessing = this.uploadingCount > 0
    }
  }
}
</script>

<style lang="scss">
.--drop {
  .v-card {
    transition: 0.3s all;
  }
}

.--input {
  position: absolute;
  height: 114px;
  width: calc(100% - 32px);
  z-index: 1;
  opacity: 0;
}

.--file-input {
  position: absolute;
  z-index: 1;
  width: 0;
  padding: 0;
  height: 1;
  margin: 0;
  opacity: 0;

  .v-text-field {
    padding: 0;
  }

  .v-input__prepend-outer {
    display: none;
  }

  .v-text-field__slot {
    height: 114px;
  }

  input[type='file'] {
    height: 114px;
    width: 100%;
  }

  .v-text-field__details {
    display: none;
  }
}
</style>
